import type { BibleSave } from "@packages/sdk";

const humanReadableColors = {
  1: "yellow",
  2: "pink",
  3: "teal",
  4: "green",
  5: "blue",
  6: "purple",
  7: "red",
  8: "orange",
};

type FunctionProps = Partial<BibleSave> & {
  screen_name: string;
  starting_color?: number;
};

export const bibleProperties = ({
  book_id,
  chapter,
  screen_name,
  translation_name,
  translation_id,
  starting_color,
  ...props
}: FunctionProps) => {
  const base = {
    bible_book_id: book_id,
    bible_chapter_id: chapter,
    bible_translation_id: translation_id,
    bible_translation_name: translation_name,
    screen_name: screen_name,
    source: screen_name === "bible" ? "bible_tab" : screen_name,
  };
  if (props.type === "notation") {
    return {
      ...base,
      highlight_color: humanReadableColors[props.color] ?? undefined,
      starting_color: humanReadableColors[starting_color] ?? undefined,
      verse_range: `${props.verse_start}${props.verse_end > props.verse_start ? `-${props.verse_end}` : ""}`,
      type: !!(props.note as string)?.length ? "note" : "highlight",
    };
  } else {
    return { ...base, type: "bookmark" };
  }
};
